import React from 'react';
import About from '../../pages/About/About';
import Banner from '../../pages/Banner/Banner';
import Contact from '../../pages/Contact/Contact';
import Service from '../../pages/Servicess/Service';
import Skill from '../../pages/Skill/Skill';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import Portfolio from '../../pages/Portfolio/Portfolio';

const Home = () => {
  return (
    <div>
      <Navbar />
      <section>
        <Banner />
        <About />
        <Skill />
        <Service />
        <Portfolio />
        <Contact />
      </section>
      <Footer />
    </div>
  );
};

export default Home;
